import { httpClient } from "./API";
import { encode } from "js-base64";

export const setAuthentication = () => {
  if (
    process.env.REACT_APP_VANCOUVER_USERNAME &&
    process.env.REACT_APP_VANCOUVER_PASSWORD
  ) {
    const s = encode(
      `${process.env.REACT_APP_VANCOUVER_USERNAME}:${process.env.REACT_APP_VANCOUVER_PASSWORD}`
    );
    httpClient.defaults.headers.common["Authorization"] = "Basic " + s;
  } else {
    console.log("not get user or password");
  }
};
